import { CommonModule } from "@angular/common";
import { HttpClient } from "@angular/common/http";
import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import { environment } from "@env/environment";
import KRGlue from "@lyracom/embedded-form-glue";
import { TranslateModule } from "@ngx-translate/core";
import { UNPAID } from "@shared/constants/payment-form.constants";
import { InputTextModule } from "primeng/inputtext";
import { firstValueFrom, of } from "rxjs";

@Component({
  selector: "app-payment-form",
  standalone: true,
  imports: [CommonModule, InputTextModule, TranslateModule],
  templateUrl: "./payment-form.component.html",
  styleUrl: "./payment-form.component.scss",
})
export class PaymentFormComponent implements AfterViewInit {
  message = "";
  @Output() paymentEvent = new EventEmitter<boolean>(false);
  @Output() showPopup = new EventEmitter<boolean>();
  @Input() formToken = "";

  constructor(
    private http: HttpClient,
    private chRef: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    const endpoint = environment.Systempay.endpoint;
    const publicKey = environment.Systempay.publicKey;
    let _formToken = "";

    const observable = of(this.formToken);
    firstValueFrom(observable)
      .then((resp: any) => {
        _formToken = resp;
        return KRGlue.loadLibrary(endpoint, publicKey);
      })
      .then(({ KR }) =>
        KR.setFormConfig({
          formToken: _formToken,
          "kr-language": "fr-FR",
          "kr-placeholder-card-holder-name": "Exemple: Jean Dupont",
          "kr-placeholder-pan": "Exemple: 5071 0032 2000 8000",
          "kr-placeholder-expiry": "Exemple: 02/27",
          "kr-placeholder-security-code": "Exemple: 111",
        })
      )
      .then(({ KR }) => KR.onSubmit(this.onSubmit))
      .then(({ KR }) => KR.onError(this.onError))
      .then(({ KR }) => KR.renderElements("#myPaymentForm")) /* Render the payment form into the specified selector*/
      .catch(error => {
        this.message = error.message + " (see console for more details)";
      });
  }

  onError = () => {
    this.paymentEvent.emit(false);
    this.showPopup.emit(true);
  };

  private onSubmit = (paymentData: KRPaymentResponse) => {
    if (paymentData.clientAnswer.orderStatus === UNPAID) {
      this.paymentEvent.emit(false);
    } else {
      this.paymentEvent.emit(true);
    }
    this.showPopup.emit(true);
  };
}
